import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";
import api from "../../Axios";
import NotificationAlert from "react-notification-alert";
import "./members.css";
import Swal from 'sweetalert2'
import Usercard from "../../components/Usercard";
import SearchField from "../../components/SearchField";
const InactiveMember = () => {
  const [data, setData] = useState([]);
  const [render, setRerender] = useState(false);

  const [active, setActive] = useState([]);
  useEffect(() => {
    api.get("/admin/adminDashboard/activeMembers").then((res) => {
      setActive(res.data.data);
    });
  }, []);
  function deletee(i) {
    api
      .post("/admin/manageuserProfile/terminateUser", { id: i.id })
      .then((r) => {
        Swal.fire(r.data.data)
        api.get("/admin/adminDashboard/activeMembers").then((res) => {
          setActive(res.data.data);
        });
      });
  }
  function changestatus(i) {
    api.post("/admin/manageuserProfile/deleteUser", { id: i.id }).then((r) => {
      Swal.fire(r.data.data)
      api.get("/admin/adminDashboard/activeMembers").then((res) => {
        setActive(res.data.data);
      });
    });
  }
  const searchMember = () => {
    let search = document.getElementById("search_id").value;
    api
      .post("/admin/manageuserprofile/searchUser", {
        searchData: search,
        query: "active",
      })
      .then((v) => {
        setActive(v.data.data);
      });
  };

  return (
    <div>
      <div className="content">
        <div className="notification-popup"></div>
        <Row>
          <Col xs={12} md={12}>
            <div className="page-title">
              <div className="float-left">
                <h1 className="title" style={{ textTransform: "capitilize" }}>
                  Active Members
                </h1>
              </div>
              <SearchField onSearch={() => searchMember()} />
            </div>
            <Row>
              {Array.isArray(active) && active.length > 0 ? (
                active.map((user, index) => (
                  <Usercard
                    id={user.id}
                    name={user.userName}
                    image={user.images}
                    age={user.age}
                    gender={user.gender}
                    dob={user.dob}
                    status={user.status}
                    state={user.state}
                    onDelete={() => deletee(user)}
                    onStatus={() => changestatus(user)}
                  />
                ))
              ) : (
                <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                  <h3> Profile Not Found</h3>
                </div>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default InactiveMember;
